import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { FeatureMarketingPreferencesTranslationDictionary } from '../models/i18n/feature-marketing-preferences-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureMarketingPreferencesTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_EMAIL_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by email',
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_POST_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by post',
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_TELEPHONE_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by telephone',
      MARKETING_PREFERENCES_FORM_SUBMIT_BUTTON: 'Continue to payment',
    },
    [LocaleId.English_Ireland]: {
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_EMAIL_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by email',
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_POST_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by post',
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_TELEPHONE_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by telephone',
      MARKETING_PREFERENCES_FORM_SUBMIT_BUTTON: 'Continue to payment',
    },
    [LocaleId.English_US]: {
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_EMAIL_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by email',
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_POST_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by post',
      MARKETING_PREFERENCES_FORM_MARKETING_PREFERENCE_TELEPHONE_ERROR_REQUIRED:
        'Please indicate if you would like to be contacted by telephone',
      MARKETING_PREFERENCES_FORM_SUBMIT_BUTTON: 'Continue to payment',
    },
  };
